export default __webpack_public_path__ + "static/media/ganba.a436f16c.jpg";